import BigNumber from 'bignumber.js';

const considerGrammaticalNumber = (digit: BigNumber, text: string) => {
  const wordsInParenthesesMatcher = /(\(|\[)([^)|^\]]+)(\)|])/g;
  let outputText = text;
  let match;

  while ((match = wordsInParenthesesMatcher.exec(text)) !== null) {
    const [fullMatch, type, groupMatch] = match;
    outputText = outputText.replace(
      fullMatch,
      type === '[' ? (digit.eq(1) ? groupMatch : '') : digit.eq(1) ? '' : groupMatch,
    );
  }
  return outputText;
};

export default considerGrammaticalNumber;
